import { PDFDocument, PDFTextField } from 'pdf-lib';

const loadPdf = async () => {
    const existingPdfBytes = await fetch('/student_injury_report_form.pdf').then((res) =>
        res.arrayBuffer()
    );

    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const form = pdfDoc.getForm();
    const fields = form.getFields();

    fields.forEach((field) => {
        if (field instanceof PDFTextField) {
        // Modify the font size of text fields
        const defaultAppearance = field.acroField.getDefaultAppearance();
        const updatedAppearance = defaultAppearance.replace(/(\d+)/, 11);
        field.acroField.setDefaultAppearance(updatedAppearance);
        }
    });
    return pdfDoc;
};

const convert24hTo12h = (time24h) => {
    const timeParts = time24h.split(":");
    const hour = parseInt(timeParts[0]);
    const minutes = parseInt(timeParts[1]);

    const time12h = new Date(0, 0, 0, hour, minutes).toLocaleTimeString([], {
        hour: "numeric",
        minute: "numeric",
        hour12: true
    }).replace(/(:\d{2}| [AP]M)$/, "");
    return time12h;
}

const fillPdfForm = (pdfDoc, textData, booleanData, dateData, dateTimeData) => {
    const form = pdfDoc.getForm();

    textData.studentNumber = textData.studentNumber.replace(/^A0/, '');

    for (const key in textData) {
        form.getTextField(key).setText(textData[key].trim());
    }

    for (const key in booleanData) {
        if (booleanData[key]) form.getRadioGroup(key).select('yes')
        else form.getRadioGroup(key).select('no');
    }

    for (const key in dateData) {
        form.getTextField(key).setText(dateData[key].replace(/-/g, '/'));
    }

    for (const key in dateTimeData) {
        const dateFieldName = key.replace('Time', "")
        const date = dateTimeData[key].substring(0, 10).replace(/-/g, '/');
        const timeFieldName = key.replace('Date', "")
        const time = convert24hTo12h(dateTimeData[key].substring(11, 16))
        form.getTextField(dateFieldName).setText(date);
        form.getTextField(timeFieldName).setText(time);

        if (time[time.length - 2] === 'P') form.getCheckBox(timeFieldName + 'CheckboxPM').check();
        else form.getCheckBox(timeFieldName + 'CheckboxAM').check();
    }

    const doubleFields = ['firstName', 'lastName', 'studentNumber']
    for (const fieldName of doubleFields) {
        form.getTextField(fieldName + '2').setText(textData[fieldName].trim());
    }
};

const generateFilledPdf = async (textData, booleanData, dateData, dateTimeData) => {
    const pdfDoc = await loadPdf()

    fillPdfForm(pdfDoc, textData, booleanData, dateData, dateTimeData)

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);

    // Trigger the file download
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = 'filled_incident_form.pdf';
    link.click();

    // Clean up the blob URL
    URL.revokeObjectURL(blobUrl);
};


// const listPdfFields = (pdfDoc) => {
//     const form = pdfDoc.getForm();
//     const fields = form.getFields();
//     const fieldNames = fields.map((field) => field.getName());
//     return fieldNames;
// };

export {
    loadPdf,
    fillPdfForm,
    generateFilledPdf,
}